var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValidator({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.50002 0.899902C2.06408 0.899902 0.900024 2.06396 0.900024 3.4999V6.0999C0.900024 7.53584 2.06408 8.6999 3.50002 8.6999H6.10002C7.53596 8.6999 8.70002 7.53584 8.70002 6.0999V3.4999C8.70002 2.06396 7.53596 0.899902 6.10002 0.899902H3.50002Z",
    fill: "#CCCDD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50002 11.2999C2.06408 11.2999 0.900024 12.464 0.900024 13.8999V16.4999C0.900024 17.9358 2.06408 19.0999 3.50002 19.0999H6.10002C7.53596 19.0999 8.70002 17.9358 8.70002 16.4999V13.8999C8.70002 12.464 7.53596 11.2999 6.10002 11.2999H3.50002Z",
    fill: "#CCCDD4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3 3.4999C11.3 2.06396 12.4641 0.899902 13.9 0.899902H16.5C17.936 0.899902 19.1 2.06396 19.1 3.4999V6.0999C19.1 7.53584 17.936 8.6999 16.5 8.6999H13.9C12.4641 8.6999 11.3 7.53584 11.3 6.0999V3.4999Z",
    fill: "#CCCDD4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3 13.8999C11.3 12.464 12.4641 11.2999 13.9 11.2999H16.5C17.936 11.2999 19.1 12.464 19.1 13.8999V16.4999C19.1 17.9358 17.936 19.0999 16.5 19.0999H13.9C12.4641 19.0999 11.3 17.9358 11.3 16.4999V13.8999Z",
    fill: "#CCCDD4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidator);
export default __webpack_public_path__ + "static/media/validator.e27dbf13.svg";
export { ForwardRef as ReactComponent };